/* Preserve keyboard position when Broadcast replaces cart line-item markup. */
(function () {
  if (window.burdlifeCartRecoveryReady) return;
  window.burdlifeCartRecoveryReady = true;
  let opener = null;
  let cartFocus = null;

  function cartRoot() {
    return document.querySelector('[data-cart-drawer].is-open, [data-cart-page]');
  }

  document.addEventListener('click', (event) => {
    const cart = cartRoot();
    if (cart?.contains(event.target)) cartFocus = event.target.closest('button, a, input, select, textarea');
    const trigger = event.target.closest('[data-cart-toggle], [data-add-to-cart], [data-quick-add-btn]');
    if (trigger && !trigger.closest('[data-cart-drawer]')) opener = trigger;
  }, true);

  document.addEventListener('focusin', (event) => {
    const cart = cartRoot();
    if (cart?.contains(event.target)) cartFocus = event.target;
  });

  document.addEventListener('theme:cart:change', () => {
    requestAnimationFrame(() => {
      const cart = cartRoot();
      if (!cart || !cartFocus || cartFocus.isConnected || document.activeElement !== document.body) return;
      const previousId = cartFocus.id;
      const previousLabel = cartFocus.getAttribute('aria-label');
      const quantityId = cartFocus.closest('quantity-counter')?.querySelector('input[data-id]')?.id;
      const quantityCounter = quantityId ? document.getElementById(quantityId)?.closest('quantity-counter') : null;
      const quantityControl = quantityCounter ? Array.from(quantityCounter.querySelectorAll('button[name]')).find((node) => node.name === cartFocus.name) : null;
      const replacement = quantityControl || (previousId ? document.getElementById(previousId) :
        previousLabel ? Array.from(cart.querySelectorAll('[aria-label]')).find((node) => node.getAttribute('aria-label') === previousLabel) : null);
      const recovery = cart.querySelector('[data-cart-empty]:not(.is-hidden) .bl-cart-recovery a');
      const target = replacement || recovery || cart.querySelector('[data-cart-drawer-close]');
      target?.focus({ preventScroll: true });
    });
  });

  document.addEventListener('theme:cart:close', () => {
    requestAnimationFrame(() => {
      const drawer = document.querySelector('[data-cart-drawer]');
      if (drawer?.classList.contains('is-open')) return;
      const focus = document.activeElement;
      if (opener?.isConnected && (focus === document.body || drawer?.contains(focus))) {
        opener.focus({ preventScroll: true });
      }
      cartFocus = null;
    });
  });
})();
